import { FundriseRouteConfig } from 'vue-router';
import VcxLanding from '@views/vcx/vcx-landing-view.vue';

const vcxRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/vcx',
		name: 'vcx-landing',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: VcxLanding
	}
];

export default vcxRoutes;
